










































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import ModalMember from '@/components/manageGroup/members/ModalMember.vue';
import { GroupItem, Member } from '@/interface/store/manageGroups';
import { User, Avatar } from '@/interface/store/profile';
import { InventoryQueryParams } from '@/interface/store/inventory';
import { RequestQueryParams } from '@/interface/store/request';

@Component({
  components: {
    ModalMember,
  },
})
export default class Gnb extends Vue {
  @Action('logOut', { namespace: 'auth' }) c_logOut!: any;
  @Action('getQueryParams', { namespace: 'inventory' }) c_getInventoryQueryParams!: any;
  @Action('getQueryParams', { namespace: 'request' }) c_getRequestQueryParams!: any;

  @Getter('getterGroupsMemberships', { namespace: 'manageGroup' })
  readonly c_getterGroupsMemberships!: Array<GroupItem>;
  @Getter('getterLastGroupId') readonly c_getterLastGroupId!: string | null;
  @Getter('getterMe', { namespace: 'manageGroup' })
  readonly c_getterMe!: Member;
  @Getter('getterUser', { namespace: 'profile' })
  readonly c_getterUser!: User;
  @Getter('getterAvatar', { namespace: 'profile' })
  readonly c_getterAvatar!: Avatar;
  @Getter('getterQueryParams', { namespace: 'inventory' })
  readonly c_getterInventoryQueryParams!: InventoryQueryParams;
  @Getter('getterQueryParams', { namespace: 'request' })
  readonly c_getterRequestQueryParams!: RequestQueryParams;

  @Mutation('RESET_ALL', { namespace: 'inventory' }) c_resetAllInventory!: any;
  @Mutation('RESET_ALL', { namespace: 'request' }) c_resetAllRequest!: any;
  @Mutation('RESET_ALL', { namespace: 'profile' }) c_resetAllProfile!: any;
  @Mutation('RESET_ALL', { namespace: 'manageGroup' }) c_resetAllManageGroups!: any;
  @Mutation('RESET_ALL') c_resetRootState!: any;

  public memberFilter = 'ACTIVE';
  public dialogVisible = false;
  public searchKeyword: string | (string | null)[] = '';

  @Watch('$route', { immediate: true, deep: true })
  onRouteChange(val: any, oldVal: any) {
    const keyword = this.$route.query.query;
    this.searchKeyword = keyword ? keyword : '';
  }

  async created() {
    // 쿼리 스트링에 검색 키워드(query) 있을 때 변수에 지정
    const keyword = this.$route.query.query;
    this.searchKeyword = keyword ? keyword : '';
  }

  get inventoryURI() {
    const uriObj = {
      componentName: 'Inventory',
      label: '재고관리',
      isGroup: false,
      limit: 20,
      page: 1,
      sort: '-updatedAt',
      icon: 'el-icon-box',
    };

    const inventoryObj = {
      limit: this.c_getterInventoryQueryParams.limit,
      page: this.c_getterInventoryQueryParams.offset + 1,
      sort: this.c_getterInventoryQueryParams.order,
    };

    Object.assign(uriObj, inventoryObj);
    uriObj.isGroup = this.c_getterGroupsMemberships.length > 0;

    return uriObj;
  }

  get requestURI() {
    const { limit, offset, order, hasDropdown, status } = this.c_getterRequestQueryParams;

    const uriObj = {
      componentName: 'Request',
      label: '구매관리',
      isGroup: false,
      icon: 'el-icon-document',
      queryObj: {
        limit: 20,
        page: 1,
        sort: '-statusChangedAt',
      },
    };

    const requestObj = {
      status: status.split(',').length === 1 ? status : status.split(','),
      limit,
      page: offset + 1,
      sort: order,
    };

    Object.assign(uriObj.queryObj, requestObj);

    if (!status) {
      delete requestObj.status;
    }
    if (hasDropdown) {
      Object.assign(uriObj.queryObj, {
        hasDropdown,
      });
    }

    uriObj.isGroup = this.c_getterGroupsMemberships.length > 0;

    return uriObj;
  }

  get searchPlaceholder() {
    let placeholder = '검색';
    const { name } = this.$route;
    if (name === 'ContentView' || name === 'DrawerInventoryItem') {
      placeholder = '재고에서 ' + placeholder;
    } else if (name === 'StatusView' || name === 'DrawerRequestItem') {
      placeholder = '요청에서 ' + placeholder;
      switch (this.$route.query.status) {
        case 'PENDING':
          placeholder = '신규 ' + placeholder;
          break;
        case 'APPROVED':
          placeholder = '승인 ' + placeholder;
          break;
        case 'ORDERED':
          placeholder = '주문 ' + placeholder;
          break;
        case 'RECEIVED':
          placeholder = '수령 ' + placeholder;
          break;
        case 'BACKORDERED':
          placeholder = '배송지연 ' + placeholder;
          break;
        case 'CANCELLED':
          placeholder = '취소 ' + placeholder;
          break;
      }
    }

    return placeholder;
  }

  onSearchKeyword(keyword: string | (string | null)[]) {
    // 검색어와 쿼리스트링 같으면 무효화
    if (this.$route.query.query === keyword) return false;
    // 검색 키워드 조회시 무조건 첫번째 페이지로 이동
    this.$route.query.page = '1';
    // 검색 키워드 없으면 초기화
    if (!keyword) {
      // 검색 키워드 텍스트 초기화
      this.searchKeyword = '';
      if (this.$route.query.query) {
        this.$router.push({ query: Object.assign({}, this.$route.query, { query: undefined }) });
      }
    } else {
      // 검색 키워드 변수 및 쿼리 스트링에 적용
      this.searchKeyword = keyword;
      this.$router.push({ query: Object.assign({}, this.$route.query, { query: keyword }) });
    }
  }

  settingGroup() {
    let paramsId: string = this.$route.params.groupId;

    if (this.c_getterGroupsMemberships.length > 0) {
      if (this.$route.params.groupId === 'welcome') {
        alert('LAB을 선택해주세요');
        return false;
      } else {
        this.$router.push({
          name: 'ManageGroup',
          params: {
            groupId: paramsId,
          },
        });
      }
    } else {
      this.$message({
        showClose: true,
        type: 'warning',
        message: 'LAB 먼저 만들어주세요.',
      });
    }
  }

  memberInviteOpen(): void {
    if (this.c_getterGroupsMemberships.length < 1) {
      this.$message({
        showClose: true,
        type: 'warning',
        message: 'LAB 먼저 만들어주세요.',
      });
    } else this.dialogVisible = true;
  }

  onModalClose(bool: boolean): void {
    this.dialogVisible = bool;
  }

  changeCommand(cb: Function) {
    cb();
  }

  setProfile() {
    this.$router.push({
      name: 'Profile',
    });
  }

  async goLogOut() {
    await this.c_logOut();
    await this.c_resetAllInventory();
    await this.c_resetAllManageGroups();
    await this.c_resetAllProfile();
    await this.c_resetAllRequest();
    await this.c_resetRootState();
  }

  onInviteSubmit(bool: boolean) {
    this.dialogVisible = bool;
  }
}
